import { useQuery } from "@tanstack/react-query";
import { CACHE_KEYS } from "@api/constants/cacheKeys";
import URLS from "@api/constants/urls";
import { handleGlobalGetRequestQuery } from "@api/functions/getRequests";
import { useState } from "react";
import {
  ICommonServiceProps,
  IGlobalMetaSchema,
} from "@api/types/globalService.types";
import useGlobalDebounceHandler from "../useGlobalDebounceHandler";
import { urlUtility } from "@repo/utilities/url.utility.ts";
import { IGenderResponseSchema } from "./genderService.types";

export const useGetAllGenderService = ({
  page = "1",
  per_page = "15",
  enableQuery,
}: ICommonServiceProps) => {
  const [searchQuery, setSearchQuery] = useState("");
  const { debouncedQuery } = useGlobalDebounceHandler(searchQuery);

  const allGendersService = useQuery({
    queryKey: [...CACHE_KEYS.GENDER, page, per_page, debouncedQuery],
    queryFn: (): Promise<{
      data: IGenderResponseSchema[];
      meta: IGlobalMetaSchema;
    }> =>
      handleGlobalGetRequestQuery({
        url: URLS.GENDER,
        searchParams: {
          page,
          per_page,
          "filter[name]": debouncedQuery,
        },
      }),
    enabled: enableQuery,
  });

  return {
    services: { allGendersService },
    states: { searchQuery, setSearchQuery },
  };
};

export const useGetSingleGenderServices = () => {
  const urlQueries = urlUtility.getUrlQueries(location.search);
  const genderId = urlQueries["edit-gender-id"] || "";
  const singleGenderService = useQuery({
    queryKey: [...CACHE_KEYS.GENDER, genderId],
    queryFn: (): Promise<{ data: IGenderResponseSchema }> =>
      handleGlobalGetRequestQuery({
        url: `${URLS.GENDER}/${genderId}`,
      }),
    enabled: !!genderId,
  });

  return {
    services: { singleGenderService },
  };
};
